import { InventoryIcon } from '../../../components/ui/icons';
import { Box, Button, Paper, Typography } from '@mui/material';

export function CollectionEmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <Paper
      elevation={0}
      sx={{ textAlign: 'center', py: { xs: 6, sm: 9 }, px: 3, borderRadius: 1 }}
    >
      <Box
        sx={{
          width: 88,
          height: 88,
          mx: 'auto',
          mb: 2.5,
          display: 'grid',
          placeItems: 'center',
          color: 'text.secondary',
        }}
      >
        <InventoryIcon sx={{ fontSize: 64, strokeWidth: 1 }} />
      </Box>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography
        color="text.secondary"
        sx={{ maxWidth: 380, mx: 'auto', lineHeight: 1.6 }}
      >
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="contained" sx={{ mt: 3 }} onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Paper>
  );
}
